<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card v-if="updateProfile" class="elevation-2">
            <v-form @submit.prevent="updateProfile">
              <v-toolbar color="primary">
                <v-toolbar-title>Profile</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
<!--              error bar-->
              <v-layout row v-if="error">
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
              </v-layout>
              <v-card-text v-if="user!==null">
                <v-text-field
                    prepend-icon="person"
                    v-model="user.name"
                    :counter="15"
                    :rules="nameRules"
                    label="Name"
                    required
                    outlined
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :disabled="loading || user.name == ''" :loading="loading">
                  Update
                <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                </span>
              </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "scafold",
  data: () => ({
    email: '',
    password: '',
    signUp: false,
    name: '',
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],

  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    updateProfile () {
      this.$store.dispatch('updateUserProfile', this.user)

    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

